// Constants
import { CONTRACT_CONSENTS_PROPS } from './constants/contract.utils.constants';
// Types
import { ConsentPropsReturnType, ConsentPropsBuilderType } from './types/contract.utils.type';

const getConsentProps = ({
  CONSENT,
  formatMessage,
  type,
}: ConsentPropsBuilderType): ConsentPropsReturnType => ({
  ...CONTRACT_CONSENTS_PROPS,
  label: formatMessage({ id: CONSENT(type) }),
});

export { getConsentProps };
